export default "__VITE_ASSET__xLTQF6nF__"